import { Container } from '../../../odie';
import { GameScene } from '../../GameScene';
import { IEffect } from '../../actions/effects/IEffect';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { blockViewAssets } from '../../util/blockTools';
import { MagicBunniesBlockEntity } from './MagicBunniesBlockEntity';
import { playSpineAnimation } from 'src/lib/ui/utils/spine';
import { app } from '../../app';
import { magicBunniesAssets } from './MagicBunniesBlockView';
import gsap from 'gsap';
import { config } from '../../defs/config';
import sounds from 'src/lib/sounds';

// Short delay before despawning the block entity
const PARTICLES_BREAK_DELAY = 0.2;
export class MagicBunniesBlockEffect implements IEffect {
  private readonly scene: GameScene;

  constructor(scene: GameScene) {
    this.scene = scene;
  }

  public static assets() {
    return blockViewAssets('magicBunnies');
  }

  public async execute() {
    //
  }

  public async playClearAnimation(entity: MagicBunniesBlockEntity) {
    // Spawn an overlay for the animation
    const container = new Container();
    const overlay = spawnOverlayEntity(
      this.scene,
      entity.c.position.mapPosition,
      entity.c.block.props,
      () => container,
      'foreground',
    );

    // Move the block view to the overlay
    const blockView = entity.c.blockMagicBunnies.view;
    container.addChild(blockView);
    blockView.x -= config.tile.size;
    blockView.y -= config.tile.size;

    // Explode all bunny hats
    const bunnies = blockView.bunnies;
    for (const bunny of bunnies) {
      // bunny.updateOpts({ superview: container.view });
      void playSpineAnimation(bunny, {
        animation: 'hat_break',
        loop: false,
        clear: true,
      });
    }

    // Wait for a short delay before playing break particles
    await gsap.to(container, { duration: PARTICLES_BREAK_DELAY });

    // Reuse some sound effects
    sounds.playSound('puzzle-lock-destroy');
    sounds.playSound('puzzle-door-poke-chain');

    // Hide the box and play break particles
    blockView.box.hide();

    // No need to await the particles to finish, just let it remove the overlay at the end
    void this.playBreakParticles(overlay.view).then(() => {
      // Remove the overlay after animation is done
      despawnOverlayEntity(this.scene, overlay);
    });
  }

  public async playBreakParticles(container: Container) {
    const particles = app.particles.create({
      textures: [
        magicBunniesAssets.piece01,
        magicBunniesAssets.piece02,
        magicBunniesAssets.piece03,
        magicBunniesAssets.piece04,
      ],
      rate: 0,
      limit: 20,
      emitterDuration: 0,
      duration: 1,
      velocity: [
        { x: 0, y: -300 },
        { x: 0, y: -600 },
      ],
      scale: [
        { x: 0.5, y: 0.5 },
        { x: 1.0, y: 1.0 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [500, 500], applyRotation: true },
        { type: 'gravity', gravity: { x: 0, y: 2500 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic', directionalRotation: true },
      ],
    });

    particles.view.x = 80;
    particles.view.y = 80;
    container.addChildAt(particles.view, 0);
    await particles.start();
  }
}
